import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const initialForm = {
  name: "",
  rnc: "",
  address: "",
  contact: "",
  phone: "",
  email: "",
  status: "Active",
};

export default function CrearProveedorDialog({ open, onClose }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  

  const handleChange = (e) => {

    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    if (!form.name) newErrors.name = "Nombre es requerido";
    if (!form.rnc) newErrors.rnc = "RNC es requerido";
    if (!form.contact) newErrors.contact = "Contacto es requerido";
    if (!form.phone) newErrors.phone = "Teléfono es requerido";
    if (!form.email) newErrors.email = "Email es requerido";
    // Basic email validation
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) newErrors.email = "Email inválido";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }

    
    const url = `${process.env.REACT_APP_SERVER_URL}/api/proveedores`;
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          nombre:form.name,
          rnc:form.rnc,
          direccion:form.address,
          contacto:form.contact,
          telefono:form.phone,
          email:form.email,
          idcompany:localStorage.getItem('idcompany'),
          estado:"activo"
        })
      });

      const text = await response.text();
      try {
        const data = JSON.parse(text);
        if (!response.ok) {
          throw new Error(data.error || 'Error al crear proveedor');
        }
        onClose()
      } catch (e) {
        throw new Error('Respuesta no es JSON: ' + text);
      }
    } catch (error) {
      setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
      throw error;
    }


  };

  const handleClose = () => {
    setForm(initialForm);
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Agregar Proveedor
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            placeholder="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
            fullWidth
          />
          <TextField
            placeholder="RNC"
            name="rnc"
            value={form.rnc}
            onChange={handleChange}
            error={!!errors.rnc}
            helperText={errors.rnc}
            fullWidth
          />
          <TextField
            placeholder="Address"
            name="address"
            value={form.address}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            placeholder="Contact"
            name="contact"
            value={form.contact}
            onChange={handleChange}
            error={!!errors.contact}
            helperText={errors.contact}
            fullWidth
          />
          <TextField
            placeholder="Phone"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            error={!!errors.phone}
            helperText={errors.phone}
            fullWidth
          />
          <TextField
            placeholder="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primarybutton" sx={{fontWeight:"bold"}}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
